import { render, staticRenderFns } from "./veStuGraduationYyxs.vue?vue&type=template&id=4cdcd5fa&scoped=true"
import script from "./veStuGraduationYyxs.vue?vue&type=script&lang=js"
export * from "./veStuGraduationYyxs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdcd5fa",
  null
  
)

export default component.exports